import { render, staticRenderFns } from "./dm-confirmation-lightbox.vue?vue&type=template&id=d651e910&scoped=true"
import script from "./dm-confirmation-lightbox.vue?vue&type=script&lang=ts"
export * from "./dm-confirmation-lightbox.vue?vue&type=script&lang=ts"
import style0 from "./dm-confirmation-lightbox.vue?vue&type=style&index=0&id=d651e910&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d651e910",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d651e910')) {
      api.createRecord('d651e910', component.options)
    } else {
      api.reload('d651e910', component.options)
    }
    module.hot.accept("./dm-confirmation-lightbox.vue?vue&type=template&id=d651e910&scoped=true", function () {
      api.rerender('d651e910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-management-overview/dm-confirmation-lightbox.vue"
export default component.exports